<template>
  <div class="gx-al">
<!--    <div class="gx-al__head">
    <gx-loading :show="loading" />
      <button class="gx-al__btn" @click="$router.back()">← 返回</button>
      <span class="gx-al__title">星人鉴图</span>
    </div>-->

    <!-- Tabs -->
<!--    <div class="gx-al__tabs">
      <button
        v-for="t in tabList"
        :key="t.value"
        class="gx-al__tab"
        :class="{ 'gx-al__tab&#45;&#45;on': activeTab === t.value }"
        @click="switchTab(t.value)"
      >
        {{ t.label }}
      </button>
      <button class="gx-al__expand" @click="toggleSearch">{{ searchVisible ? '收起' : '展开' }} {{ searchVisible ? '▲' : '▼' }}</button>
    </div>-->

    <!-- 搜索 -->
    <div v-if="searchVisible" class="gx-al__filter">
      <div class="gx-al__frow">
          <div class="search-wrap custom-form-wrap">
              <el-form inline size="mini" :model="searchParams" ref="searchForm" label-position="top">
                <el-form-item label="商品标题">
                    <el-input v-model="searchParams.title" placeholder="请输入商品标题" clearable></el-input>
                  </el-form-item>
                  <el-form-item label="检测状态">
                    <el-select v-model="searchParams.status" clearable placeholder="全部" class="w200"  @change="handleSearch">
                        <el-option v-for="(label, v) in (filterConfig.status_filter || {})" :key="v" :label="label" :value="v"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="违规方向">
                    <el-select v-model="searchParams.violation" clearable placeholder="全部" class="w200"  @change="handleSearch">
                        <el-option v-for="(label, v) in (filterConfig.violation_filter || {})" :key="v" :label="label" :value="v"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="鉴图状态">
                    <el-select v-model="searchParams.appraisal_status" clearable placeholder="全部" class="w200"  @change="handleSearch">
                        <el-option v-for="(label, v) in (filterConfig.appraisal_status_filter || {})" :key="v" :label="label" :value="v"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="分组">
                    <el-select v-model="searchParams.group_id" clearable placeholder="全部" class="w200" multiple  collapse-tags  @change="changeGroupIds">
                        <el-option v-for="g in groupList" :key="g.id" :label="g.name" :value="g.id"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="子分组">
                    <el-select v-model="searchParams.child_group_id" clearable placeholder="全部" class="w200" multiple  collapse-tags  @change="handleSearch">
                        <el-option v-for="g in childGroupList" :key="g.id" :label="g.name" :value="g.id"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="sku替换状态">
                    <el-select v-model="searchParams.sku_status" clearable placeholder="全部" class="w200"  @change="handleSearch">
                        <el-option v-for="(label, v) in skuStatus" :key="v" :label="label.label" :value="v"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="商品库状态">
                    <el-select v-model="searchParams.item_status" clearable placeholder="全部" class="w200"  @change="handleSearch">
                        <el-option v-for="(label, v) in itemStatus" :key="v" :label="label.label" :value="v"></el-option>
                    </el-select>
                  </el-form-item>
                </el-form>
            </div>


        <!-- <div class="gx-al__fitem gx-al__fitem--col">
          <label class="gx-al__flabel">商品标题</label>
          <input v-model="searchParams.title" class="gx-al__input" placeholder="请输入商品标题" @keyup.enter="handleSearch" />
        </div>
        <div class="gx-al__fitem gx-al__fitem--col">
          <label class="gx-al__flabel">检测状态</label>
          <select v-model="searchParams.status" class="gx-al__select">
            <option value="">全部</option>
            <option v-for="(label, key) in (filterConfig.status_filter || {})" :key="key" :value="key">{{ label }}</option>
          </select>
        </div> -->
        <!-- <div class="gx-al__fitem gx-al__fitem--col">
          <label class="gx-al__flabel">违规方向</label>
          <select v-model="searchParams.violation" class="gx-al__select">
            <option value="">全部</option>
            <option v-for="(label, key) in (filterConfig.violation_filter || {})" :key="key" :value="key">{{ label }}</option>
          </select>
        </div> -->
        <!-- <div class="gx-al__fitem gx-al__fitem--col">
          <label class="gx-al__flabel">鉴图状态</label>
          <select v-model="searchParams.appraisal_status" class="gx-al__select">
            <option value="">全部</option>
            <option v-for="(label, key) in (filterConfig.appraisal_status_filter || {})" :key="key" :value="key">{{ label }}</option>
          </select>
        </div> -->
        <!-- <div class="gx-al__fitem gx-al__fitem--col">
          <label class="gx-al__flabel">分组</label>
          <multi-select v-model="searchParams.group_id" :options="groupList" placeholder="全部" @input="changeGroupIds" />
        </div>
        <div class="gx-al__fitem gx-al__fitem--col">
          <label class="gx-al__flabel">子分组</label>
          <multi-select v-model="searchParams.child_group_id" :options="childGroupList" placeholder="全部" />
        </div> -->
        <!-- <div class="gx-al__fitem gx-al__fitem--col">
          <label class="gx-al__flabel">sku替换状态</label>
          <select v-model="searchParams.sku_status" class="gx-al__select">
            <option value="">全部</option>
            <option v-for="(v, k) in skuStatus" :key="k" :value="k">{{ v.label }}</option>
          </select>
        </div> -->
        <!-- <div class="gx-al__fitem gx-al__fitem--col">
          <label class="gx-al__flabel">商品库状态</label>
          <select v-model="searchParams.item_status" class="gx-al__select">
            <option value="">全部</option>
            <option v-for="(v, k) in itemStatus" :key="k" :value="k">{{ v.label }}</option>
          </select>
        </div> -->
      </div>
      <div class="gx-al__frow gx-al__frow--bottom">
        <div class="gx-al__btns">
          <button class="gx-al__btn gx-al__btn--primary" @click="handleSearch">查询</button>
          <button class="gx-al__btn" @click="refresh">重置</button>
        </div>
      </div>
    </div>

    <!-- 主体 -->
    <div class="gx-al__content">
      <!-- 左侧：商品列表 -->
      <div class="gx-al__left">
        <div v-if="activeTab == 9" class="gx-al__progress">
          <span class="gx-al__progress_tip">进度：</span>
          <span class="gx-al__progress_label">商户待删除：</span>  <span class="gx-al__progress_txt">{{ delProgress.merchant_num || 0 }}</span>
          <span class="gx-al__progress_label">系统待删除：</span>  <span class="gx-al__progress_txt">{{ delProgress.system_num || 0 }}</span>
          <span class="gx-al__progress_label">商户排名：</span>  <span class="gx-al__progress_txt">{{ delProgress.ranking || 0 }}</span>
        </div>
        <div class="gx-al__leftbar">
          <div style="display: flex">
            <label class="gx-al__checkall">
              <input type="checkbox" :checked="checkAll" @change="handleCheckAllChange($event.target.checked)" />
              <span class="gx-al__box" :class="{ 'gx-al__box--on': checkAll }">
                <svg v-if="checkAll" width="9" height="9" viewBox="0 0 8 8" fill="none"><path d="M1 4l2 2 4-4" stroke="#F4F6F8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /></svg>
              </span>
              全选
            </label>
            <button class="gx-al__op" @click="handleClearAll">清空勾选</button>
            <button class="gx-al__op" @click="getSystemDelProgress" style="margin-left: 10px;">刷新</button>
          </div>
          <div class="gx-al__shortcuts">
            <span class="gx-al__shortcut-title">快捷键 ▾</span>
            <div class="gx-al__shortcut-panel">
              <div>上一件商品（w）</div>
              <div>下一件商品（s）</div>
              <div>未鉴图（f）</div>
              <div>鉴图有违规（a）</div>
              <div>鉴图无违规（d）</div>
              <div>多图模式-上一张（q）</div>
              <div>多图模式-下一张（e）</div>
              <div>多图模式-标记违规（r）</div>
              <div>多图模式-标记正常（t）</div>
            </div>
          </div>
        </div>
        <div class="gx-al__leftbar">
          <div></div>
          <div style="gap: 5px;display: flex;">
            <template v-if="activeTab == 9 || activeTab == 8">
              <button v-if="activeTab == 9" class="gx-al__op" @click="handleDelMarkAll">删除所有标记</button>
              <button class="gx-al__op" @click="handleDelDesAll">删除指定违规</button>
            </template>
            <button class="gx-al__op gx-al__op--danger" :disabled="!checkedList.length" @click="batchDown">批量下架</button>
            <button class="gx-al__op" :disabled="!checkedList.length" @click="handleBatchSetGroup">批量分组</button>
          </div>
        </div>
        <div ref="goodsList" class="gx-al__goodslist">
          <div v-for="(item, index) in tableData" :key="index" class="gx-al__goodsitem">
            <label class="gx-al__goodscheck">
              <input type="checkbox" :checked="item.checked" @change="handleCheckSingleChange($event.target.checked, item)" />
              <span class="gx-al__box" :class="{ 'gx-al__box--on': item.checked }">
                <svg v-if="item.checked" width="9" height="9" viewBox="0 0 8 8" fill="none"><path d="M1 4l2 2 4-4" stroke="#F4F6F8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /></svg>
              </span>
            </label>
            <div class="gx-al__iteminfo" :class="{ 'gx-al__iteminfo--on': item.id == currentGoods.id }" @click="selectGoods(item, index)">
              <div class="gx-al__itemhead">
                <el-popover
                    placement="top"
                    :fallback-placements="[ 'top', 'right', 'left','bottom']"
                    width="350"
                    trigger="hover" :disabled="!item.image">
                  <div class="popover-content">
                    <el-image :src="item.image" fit="contain" style="width:100%;height: auto"></el-image>
                  </div>
                  <span slot="reference" class="gx-al__itemimg"><img v-if="item.image" :src="item.image" alt="" /><span v-else>🛍️</span></span>
                </el-popover>

                <div class="gx-al__itembody">
                  <div class="gx-al__itemtitle" :title="item.title">{{ item.title }}</div>
                  <div class="gx-al__itemmeta">
                    <span class="gx-al__green">使用算力：<span style="font-weight: 700;color: rgb(212, 169, 70);">{{ powerNumOf(item) }}</span></span>
                    <span style="margin-left: 8px;" :style="item.status==5?'color:green':item.status==6?'color:red':'color:gray'">{{ filterConfig.status_filter ? filterConfig.status_filter[item.status] : '' }}</span>
                  </div>
                  <div class="gx-al__appraisal">
                    <span
                      v-for="(label, key) in (filterConfig.appraisal_status_filter || {})"
                      :key="key"
                      class="gx-al__appraisal-tag"
                      :class="{ 'gx-al__appraisal-tag--on': item.appraisal_status == key }"
                      @click.stop="changeAppraisalStatus(item, key)"
                    >{{ label }}</span>
                  </div>
                  <div v-if="item.remark" class="gx-al__red">{{ item.remark }}</div>
                </div>
              </div>
              <div class="gx-al__itemstat">
                <template v-if="activeTab == 1">
                  售假数量：<span class="gx-al__itemnum">{{ item.image_detection ? item.image_detection.counterfeit_num : 0 }}</span> || 第三方诱导数量：
                  <span class="gx-al__itemnum">{{ item.image_detection ? item.image_detection.inducement_num : 0 }}</span> || 违禁数量：
                  <span class="gx-al__itemnum">{{ item.image_detection ? item.image_detection.prohibited_num : 0 }}</span> || 版权IP数量：
                  <span class="gx-al__itemnum">{{ item.image_detection ? item.image_detection.copyright_num : 0 }}</span> || 肖像权数量：
                  <span class="gx-al__itemnum">{{ item.image_detection ? item.image_detection.portrait_num : 0 }}</span> || 虚假促销数量：
                  <span class="gx-al__itemnum">{{ item.image_detection ? item.image_detection.false_promotion_num : 0 }}</span>
                </template>
                <template v-if="activeTab == 9">
                  售假数量：<span class="gx-al__itemnum">{{ item.image_detection_ai ? item.image_detection_ai.counterfeit_num : 0 }}</span> || 第三方诱导数量：
                  <span class="gx-al__itemnum">{{ item.image_detection_ai ? item.image_detection_ai.inducement_num : 0 }}</span> || 违禁数量：
                  <span class="gx-al__itemnum">{{ item.image_detection_ai ? item.image_detection_ai.prohibited_num : 0 }}</span> || 版权IP数量：
                  <span class="gx-al__itemnum">{{ item.image_detection_ai ? item.image_detection_ai.copyright_num : 0 }}</span> || 肖像权数量：
                  <span class="gx-al__itemnum">{{ item.image_detection_ai ? item.image_detection_ai.portrait_num : 0 }}</span> || 虚假促销数量：
                  <span class="gx-al__itemnum">{{ item.image_detection_ai ? item.image_detection_ai.false_promotion_num : 0 }}</span> || 材质信息不一致数量：
                  <span class="gx-al__itemnum">{{ item.image_detection_ai ? item.image_detection_ai.diffrent_material_num : 0 }}</span>
                </template>
                <template v-if="activeTab == 8">
                  涉医功效虚假数量：<span class="gx-al__itemnum">{{ item.image_detection_false ? item.image_detection_false.medical_effect_false_num : 0 }}</span> || 特化功效虚假数量：
                  <span class="gx-al__itemnum">{{ item.image_detection_false ? item.image_detection_false.special_effect_false_num : 0 }}</span> || 其他功效虚假数量：
                  <span class="gx-al__itemnum">{{ item.image_detection_false ? item.image_detection_false.other_effect_false_num : 0 }}</span> || 器械药品宣传不一致数量：
                  <span class="gx-al__itemnum">{{ item.image_detection_false ? item.image_detection_false.device_drug_inconsistent_num : 0 }}</span>
                </template>
              </div>
              <div v-if="item.item_product" class="gx-al__itemmeta">
                所属分组：{{ item.item_product.group ? item.item_product.group.name : '未分组' }} || 鉴图类别：<span class="gx-al__tag" v-if="item.detection_type">{{ item.detection_type == 99 ? '人工鉴图' : '星人鉴图' }}</span>
              </div>
              <div v-else-if="item.group" class="gx-al__itemmeta">所属分组：{{ item.group.name || '未分组' }}</div>
              <div v-if="item.item_product" class="gx-al__itemmeta">
                sku替换状态：<span :style="{ color: skuStatus[item.item_product.sku_status] ? skuStatusColor[skuStatus[item.item_product.sku_status].type] : '' }">{{ skuStatus[item.item_product.sku_status] ? skuStatus[item.item_product.sku_status].label : '' }}</span> || 商品库状态：<span :style="{ color: itemStatus[item.item_product.item_status] ? itemStatusColor[itemStatus[item.item_product.item_status].type] : '' }">{{ itemStatus[item.item_product.item_status] ? itemStatus[item.item_product.item_status].label : '' }}</span>
              </div>
              <div v-else-if="item.sku_status" class="gx-al__itemmeta">
                sku替换状态：<span :style="{ color: skuStatus[item.sku_status] ? skuStatusColor[skuStatus[item.sku_status].type] : '' }">{{ skuStatus[item.sku_status] ? skuStatus[item.sku_status].label : '' }}</span> || 商品库状态：<span :style="{ color: itemStatus[item.item_status == '4' ? 4 : 1] ? itemStatusColor[itemStatus[item.item_status == '4' ? 4 : 1].type] : '' }">{{ itemStatus[item.item_status == '4' ? 4 : 1] ? itemStatus[item.item_status == '4' ? 4 : 1].label : '' }}</span>
              </div>
              <div v-if="item.task_batch" class="gx-al__itemmeta">所属任务：{{ item.task_batch.task_no }}</div>
            </div>
          </div>
          <div v-if="!tableData.length" class="gx-al__empty">暂无商品</div>
        </div>
        <div class="gx-al__pager" v-if="pageData.total > 1">
          <div class="gx-al__pager-left custom-el-wrapper">
            <span class="gx-al__pager-total">共 {{ pageData.total }} 条</span>
<!--            <page-size-select :value="pageData.limit" :options="pageSizeOptions" @change="onPageSizeChange" />-->
            <el-select size="mini" v-model="pageData.limit" @change="onPageSizeChange" class="gx-al__pager-select">
              <el-option v-for="item in [10,20,50,100,200,500,1000]" :key="item" :value="item" :label="`${item}条/页`"></el-option>
            </el-select>
          </div>
          <div class="gx-al__pager-btns">
            <button class="gx-al__page" :disabled="pageData.page <= 1" @click="getDataList(pageData.page - 1)">上一页</button>
            <button v-for="n in pages" :key="n" class="gx-al__page" :class="{ 'gx-al__page--on': n === pageData.page }" @click="getDataList(n)">{{ n }}</button>
            <button class="gx-al__page" :disabled="pageData.page >= totalPages" @click="getDataList(pageData.page + 1)">下一页</button>
          </div>
        </div>
      </div>

      <!-- 右侧：详情 -->
      <div v-if="currentGoods.id" class="gx-al__right">
        <div class="gx-al__toolbar">
          <div class="gx-al__seg">
            <button class="gx-al__seg-btn" :class="{ 'gx-al__seg-btn--on': imgMode === 'list' }" @click="switchImgMode('list')">列表模式</button>
            <button class="gx-al__seg-btn" :class="{ 'gx-al__seg-btn--on': imgMode === 'more' }" @click="switchImgMode('more')">多图模式</button>
          </div>
          <label class="gx-al__check"><input type="checkbox" v-model="showTitle" /><span class="gx-al__box" :class="{ 'gx-al__box--on': showTitle }"><svg v-if="showTitle" width="9" height="9" viewBox="0 0 8 8" fill="none"><path d="M1 4l2 2 4-4" stroke="#F4F6F8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /></svg></span> 显示标题</label>
          <label class="gx-al__check"><input type="checkbox" v-model="onlyViolation" @change="changeViolation" /><span class="gx-al__box" :class="{ 'gx-al__box--on': onlyViolation }"><svg v-if="onlyViolation" width="9" height="9" viewBox="0 0 8 8" fill="none"><path d="M1 4l2 2 4-4" stroke="#F4F6F8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /></svg></span> 只看违规图</label>
          <select v-model="imgSize" class="gx-al__select">
            <option value="big">图片大小：大号</option>
            <option value="medium">图片大小：中号</option>
            <option value="small">图片大小：小号</option>
          </select>
          <button v-if="activeTab == 9 || activeTab == 8" class="gx-al__op" @click="handleDelDesignate">删除指定违规</button>
          <div class="gx-al__markbar">
            <label class="gx-al__check">
              <input type="checkbox" :checked="markCheckAll" @change="changeMarkCheckAll($event.target.checked)" />
              <span class="gx-al__box" :class="{ 'gx-al__box--on': markCheckAll }">
                <svg v-if="markCheckAll" width="9" height="9" viewBox="0 0 8 8" fill="none"><path d="M1 4l2 2 4-4" stroke="#F4F6F8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /></svg>
                <span v-else-if="markIsIndeterminate" class="gx-al__box-dash"></span>
              </span>
              全选
            </label>
            <button class="gx-al__op" :disabled="!markCheckList.length" :class="{ 'gx-al__op--loading': markLoadingR }" @click="handleMarkImg(1)">标记图片违规</button>
            <button class="gx-al__op" :disabled="!markCheckList.length" :class="{ 'gx-al__op--loading': markLoadingT }" @click="handleMarkImg(0)">标记图片正常</button>
            <button class="gx-al__op gx-al__op--danger" :disabled="!markCheckList.length" @click="handleDelImgBatch">批量删除</button>
          </div>
        </div>

        <div v-if="showTitle" class="gx-al__desc">
          <div><span class="gx-al__flabel">标题：</span>{{ currentGoods.title }}</div>
          <div v-if="triggerWord"><span class="gx-al__flabel">触发材质词：</span><span class="gx-al__red">{{ triggerWord }}</span></div>
        </div>

        <div class="gx-al__imgarea" :class="{'gx-al__imgarea--more':imgMode === 'more'}">
          <!-- 多图模式 -->
          <div v-if="imgMode === 'more'" class="gx-al__imgmore">
            <div class="gx-al__imgmain">
              <img v-if="currentImg.origin_url" :src="currentImg.origin_url" class="gx-al__imgmain-img" :class="imgSize + '-img'" alt="" @click="handlePreview(currentImg, currentImgIndex[0], currentImgIndex[1])" />
              <span v-if="currentImg.is_mark == 1" class="gx-al__tag gx-al__tag--ok" style="margin-top: 6px;">已标记</span>
              <div class="gx-al__imgbtns">
                <button class="gx-al__op" @click="handlePre">上一张（q）</button>
                <button class="gx-al__op" @click="handleNext">下一张（e）</button>
                <button class="gx-al__op" @click="handleMarkImgSingle(1)">标记违规（r）</button>
                <button class="gx-al__op" @click="handleMarkImgSingle(0)">标记正常（t）</button>
                <button v-if="currentImg.image_type == 2 || currentImg.image_type == 3" class="gx-al__op gx-al__op--danger" @click="handleDelImg(currentImg, currentImgIndex)">删除</button>
              </div>
              <div v-if="currentImg.remark" class="gx-al__red gx-al__imgremark">{{ currentImg.remark }}</div>
            </div>
          </div>

          <!-- 图片分组列表 -->
          <div class="gx-al__imggroups">
            <div v-for="(item, index) in detailInfo" :key="index">
              <div class="gx-al__imglabel">{{ item.label }}</div>
              <div class="gx-al__imglist">
                <div
                  v-for="(img, sindex) in item.list"
                  :key="index + '_' + sindex"
                  class="gx-al__imgitem"
                  :class="{ 'gx-al__imgitem--on': imgMode == 'more' && currentImgIndex[0] == index && currentImgIndex[1] == sindex }"
                  @click="selectImg(index, sindex)"
                >
                  <div v-if="imgMode == 'list'" class="gx-al__imgcheck">
                    <label class="gx-al__check" @click.stop>
                      <input type="checkbox" :checked="markCheckList.includes(img.detail_id)" @change="changeMarkCheckSingle($event.target.checked, img.detail_id)" />
                      <span class="gx-al__box" :class="{ 'gx-al__box--on': markCheckList.includes(img.detail_id) }">
                        <svg v-if="markCheckList.includes(img.detail_id)" width="9" height="9" viewBox="0 0 8 8" fill="none"><path d="M1 4l2 2 4-4" stroke="#F4F6F8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /></svg>
                      </span>
                    </label>
                  </div>
                  <div v-if="imgMode == 'list' && img.is_mark == 1" class="gx-al__imgmark"><span class="gx-al__tag gx-al__tag--ok">已标记</span></div>
                  <span class="gx-al__imgthumb">
                    <img v-if="img.origin_url" :src="img.origin_url" alt="" @click.stop="handlePreview(img, index, sindex)" />
                  </span>
                  <template v-if="imgMode == 'list'">
                    <button v-if="img.image_type == 2 || img.image_type == 3" class="gx-al__imgdel" @click.stop="handleDelImg(img, [index, sindex])">✕</button>
                    <div v-if="img.remark" class="gx-al__red gx-al__imgremark--sm">{{ img.remark }}</div>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="gx-al__empty gx-al__right-empty">请选择左侧商品查看详情</div>
    </div>

    <!-- 弹窗：批量分组 -->
    <div v-if="batchGroupShow" class="gx-al__modal" @click.self="batchGroupShow = false">
      <div class="gx-al__modal-box gx-al__modal-box--sm">
        <div class="gx-al__modal-head">
          <span class="gx-al__modal-title">设置分组</span>
          <button class="gx-al__modal-close" @click="batchGroupShow = false">✕</button>
        </div>
        <div class="gx-al__modal-body">
          <div class="gx-al__field">
            <label class="gx-al__label">选择分组</label>
            <select v-model="batchGroupId" class="gx-al__select gx-al__select--full" @change="changeBatchGroupIds">
              <option value="0">不加入分组</option>
              <option v-for="g in groupList" :key="g.id" :value="g.id">{{ g.name }}</option>
            </select>
            <div class="gx-al__dim">选择"不加入分组"将去除商品的当前分组</div>
          </div>
          <div class="gx-al__field" v-if="batchGroupId != 0">
            <label class="gx-al__label">选择子分组</label>
            <select v-model="batchChildGroupId" class="gx-al__select gx-al__select--full">
              <option value="0">不加入分组</option>
              <option v-for="g in batchChildGroupList" :key="g.id" :value="g.id">{{ g.name }}</option>
            </select>
            <div class="gx-al__dim">选择"不加入分组"将去除商品的当前分组</div>
          </div>
        </div>
        <div class="gx-al__modal-foot">
          <button class="gx-al__btn" @click="batchGroupShow = false">取消</button>
          <button class="gx-al__btn gx-al__btn--primary" :disabled="batchGroupLoading" @click="submitBatchSetGroup">
            {{ batchGroupLoading ? '提交中...' : '确定' }}
          </button>
        </div>
      </div>
    </div>

    <!-- 弹窗：删除指定违规 -->
    <div v-if="delDesignateShow" class="gx-al__modal" @click.self="delDesignateShow = false">
      <div class="gx-al__modal-box">
        <div class="gx-al__modal-head">
          <span class="gx-al__modal-title">删除指定违规</span>
          <button class="gx-al__modal-close" @click="delDesignateShow = false">✕</button>
        </div>
        <div class="gx-al__modal-body">
          <div class="gx-al__field custom-el-wrapper">
            <label class="gx-al__label">违规项：</label>
            <template v-if="activeTab == 9">
              <el-checkbox v-model="delDesignateInfo.is_counterfeit" :true-label="1" :false-label="0">包含售假违规</el-checkbox>
              <el-checkbox v-model="delDesignateInfo.is_inducement" :true-label="1" :false-label="0">包含诱导违规</el-checkbox>
              <el-checkbox v-model="delDesignateInfo.is_prohibited" :true-label="1" :false-label="0">包含违禁违规</el-checkbox>
              <el-checkbox v-model="delDesignateInfo.is_copyright" :true-label="1" :false-label="0">包含版权IP违规</el-checkbox>
              <el-checkbox v-model="delDesignateInfo.is_portrait" :true-label="1" :false-label="0">包含名人肖像权</el-checkbox>
              <el-checkbox v-model="delDesignateInfo.is_false_promotion" :true-label="1" :false-label="0">包含虚假促销</el-checkbox>
              <el-checkbox v-model="delDesignateInfo.is_diffrent_material" :true-label="1" :false-label="0">包含材质信息不一致</el-checkbox>

            </template>
            <template v-if="activeTab == 8">
              <el-checkbox v-model="delDesignateInfo.is_medical_effect_false" :true-label="1" :false-label="0">是否涉医功效虚假</el-checkbox>
              <el-checkbox v-model="delDesignateInfo.is_special_effect_false" :true-label="1" :false-label="0">是否特化功效虚假</el-checkbox>
              <el-checkbox v-model="delDesignateInfo.is_other_effect_false" :true-label="1" :false-label="0">是否其他功效虚假</el-checkbox>
              <el-checkbox v-model="delDesignateInfo.is_device_drug_inconsistent" :true-label="1" :false-label="0">是否器械药品宣传不一致</el-checkbox>
            </template>
          </div>
          <div class="gx-al__field" v-if="delDesignateType === 'all'">
            <label class="gx-al__label">分组：</label>
            <multi-select v-model="delDesignateInfo.group_ids" :options="groupList" placeholder="全部" @input="changeDeldesignateGroupIds" />
          </div>
          <div class="gx-al__field" v-if="delDesignateType === 'all'">
            <label class="gx-al__label">子分组：</label>
            <multi-select v-model="delDesignateInfo.child_group_id" :options="delChildGroupList" placeholder="全部" />
          </div>
        </div>
        <div class="gx-al__modal-foot">
          <button class="gx-al__btn" @click="delDesignateShow = false">取消</button>
          <button class="gx-al__btn gx-al__btn--primary" :disabled="delLoading2" @click="submitDelDesignate">
            {{ delLoading2 ? '提交中...' : '确定' }}
          </button>
        </div>
      </div>
    </div>

    <!-- 弹窗：图片预览 -->
    <div v-if="previewShow" class="gx-al__modal gx-al__modal--preview" @click.self="closePreview">
      <div class="gx-al__preview">
        <button class="gx-al__preview-close" @click="closePreview">✕</button>
        <button class="gx-al__preview-nav gx-al__preview-nav--prev" @click="previewNav(-1)">‹</button>
        <img v-if="previewShow" :src="previewList[previewIndex]" class="gx-al__preview-img" alt="" @click.stop />
        <button class="gx-al__preview-nav gx-al__preview-nav--next" @click="previewNav(1)">›</button>
        <div class="gx-al__preview-count">{{ previewIndex + 1 }} / {{ previewList.length }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import GxLoading from '../../components/newUi/GxLoading.vue'
import PageSizeSelect from '../../components/newUi/PageSizeSelect.vue'
import gxLoading from '../../mixins/gxLoading'
import MultiSelect from '../cloudOptimize/MultiSelect.vue'

export default {
  name: 'NewAlienCheckPage',
  components: { MultiSelect, GxLoading, PageSizeSelect },
  mixins: [gxLoading],
  props:{alienType:{type:Number,default:9}},
  data() {
    return {
      tabList: [
        { label: 'AI检测', value: '9' },
        { label: '虚假检测', value: '8' }
      ],
      activeTab: '9',
      currentGoods: {},
      currentGoodsIndex: -1,
      imgMode: 'list',
      searchVisible: true,
      currentImgIndex: [0, 0],
      loading: false,
      searchParams: {
        status: '', title: '', task_no: '', detection_type: '', detection_scope: '',
        include_cover: '', include_main: '', include_detail: '', include_sku: '',
        detection_direction: '', appraisal_status: '', sku_status: '', group_id: [],
        child_group_id: [], item_status: '1', detection_category: '', violation: ''
      },
      tableData: [],
      pageData: { limit: 50, page: 1, total: 0 },
      pageSizeOptions: [10, 20, 50, 100, 200],
      filterConfig: {},
      skuStatus: { 1: { label: '未替换', type: 'info' }, 2: { label: '已替换', type: 'success' }, 3: { label: '找不到', type: 'error' } },
      skuStatusColor: { info: 'rgb(251, 146, 60)', success: '#67C23A', error: '#F56C6C' },
      itemStatus: { 1: { label: '成功', type: 'success' }, 4: { label: '手动下架', type: 'error' } },
      itemStatusColor: { success: '#67C23A', error: '#F56C6C' },
      groupList: [],
      childGroupList: [],
      batchChildGroupList: [],
      delChildGroupList: [],
      detailLoading: false,
      detailInfo: {},
      oldImgList: [],
      imageTypeFilter: {},
      imgList: [],
      imgSize: 'medium',
      onlyViolation: false,
      processedImages: {},
      previewList: [],
      previewIndex: 0,
      previewShow: false,
      checkedList: [],
      batchGroupShow: false,
      batchGroupId: 0,
      batchChildGroupId: 0,
      batchGroupLoading: false,
      markCheckList: [],
      markCheckAll: false,
      markIsIndeterminate: false,
      markLoadingR: false,
      markLoadingT: false,
      delLoading: false,
      delDesignateType: 'one',
      delDesignateShow: false,
      delDesignateInfo: {},
      delLoading2: false,
      delProgress: {},
      showTitle: true,
      triggerWord: ''
    }
  },
  watch:{
    alienType(val){
      this.switchTab(val)
    }
  },
  computed: {
    currentImg() {
      if (!this.detailInfo.length) return {}
      const group = this.detailInfo[this.currentImgIndex[0]]
      if (!group || !group.list) return {}
      return group.list[this.currentImgIndex[1]] || {}
    },
    checkAll() {
      const checkedCount = this.tableData.filter(i => i.checked).length
      return checkedCount > 0 && checkedCount === this.tableData.length
    },
    isIndeterminate() {
      const checkedCount = this.tableData.filter(i => i.checked).length
      return checkedCount > 0 && checkedCount < this.tableData.length
    },
    totalPages() {
      return Math.max(1, Math.ceil(this.pageData.total / this.pageData.limit))
    },
    pages() {
      const nums = []
      const start = Math.max(1, Math.min(this.pageData.page - 2, this.totalPages - 4))
      for (let i = start; i <= Math.min(this.totalPages, start + 4); i++) nums.push(i)
      return nums.length ? nums : [1]
    }
  },
  mounted() {
    this.activeTab = this.alienType
    window.addEventListener('keydown', this.handleKeydown)
    const taskNo = this.$route.query.task_no
    if (taskNo) {
      this.searchParams.task_no = taskNo
      this.handleSearch()
    } else {
      this.refresh()
    }
    this.getGroupList()
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.handleKeydown)
  },
  methods: {
    ...mapActions({
      getAlienDetectionList2: 'ucenter/getAlienDetectionList2',
      getAlienDetectionDetail2: 'ucenter/getAlienDetectionDetail2',
      opUpdateAppraisalStatus: 'ucenter/opUpdateAppraisalStatus',
      getCloudProductGroups: 'ucenter/getCloudProductGroups',
      opAlienBatchOperation: 'ucenter/opAlienBatchOperation',
      opCloudProductBatchSetGroup: 'ucenter/opCloudProductBatchSetGroup',
      opAlienDetailMark: 'ucenter/opAlienDetailMark',
      opAlienDetailDelBatch: 'ucenter/opAlienDetailDelBatch',
      opAlienDetailDelDesignate: 'ucenter/opAlienDetailDelDesignate',
      opAlienItemDelDesignateAll: 'ucenter/opAlienItemDelDesignateAll',
      opAlienDelMarkAll: 'ucenter/opAlienDelMarkAll',
      getAlienSystemDelProgress: 'ucenter/getAlienSystemDelProgress'
    }),
    powerNumOf(item) {
      if (this.activeTab == 1) return item.power_num || 0
      if (this.activeTab == 9) return (item.image_detection_ai && item.image_detection_ai.power_num) || 0
      if (this.activeTab == 8) return (item.image_detection_false && item.image_detection_false.power_num) || 0
      return 0
    },
    switchTab(val) {
      this.activeTab = val
      this.refresh()
    },
    toggleSearch() {
      this.searchVisible = !this.searchVisible
      if (!this.searchVisible) this.imgSize = 'big'
      else this.imgSize = 'medium'
    },
    getGroupList() {
      this.getCloudProductGroups({
        data: { with_count: 0 },
        success: (res) => {
          if (res.code === 200) this.groupList = res.data || []
        }
      })
    },
    getSystemDelProgress() {
      this.getAlienSystemDelProgress({
        data: {},
        success: (res) => {
          if (res.code === 200) {
            this.delProgress = res.data
          } else {
            this.$message.error(res.message)
          }
        }
      })
    },
    refresh() {
      this.pageData.page = 1
      this.pageData.total = 0
      this.tableData = []
      this.currentGoods = {}
      this.checkedList = []
      this.searchParams = { item_status: '1' }
      this.getDataList()
      if (this.activeTab == 9) {
        this.getSystemDelProgress()
      }
    },
    handleSearch() {
      this.pageData.page = 1
      this.tableData = []
      this.getDataList()
    },
    onPageSizeChange(size) {
      this.pageData.limit = size
      this.pageData.page = 1
      this.getDataList(1)
    },
    getDataList(page) {
      this.pageData.page = page || this.pageData.page
      this.currentGoodsIndex = -1
      this.tableData = []
      const param = { page_size: this.pageData.limit, page: this.pageData.page, ...this.searchParams }
      param.detection_type = this.activeTab
      this.loadingStart()
      this.getAlienDetectionList2({
        data: param,
        success: (res) => {
          this.loadingEnd()
          if (res.code === 200) {
            this.tableData = (res.data.list || []).map(i => {
              i.checked = this.checkedList.includes(i.id)
              return i
            })
            this.pageData.total = res.data.total || 0
            this.filterConfig = { ...res.data }
            delete this.filterConfig.list
            if (!this.tableData.length) this.currentGoods = {}
            if (this.tableData.length && !this.currentGoods.id) {
              this.selectGoods(this.tableData[0], 0)
            }
          } else {
            this.$message.error(res.message)
          }
        }
      })
    },
    selectGoods(item, index) {
      if (!item) return
      this.currentGoodsIndex = index
      this.currentGoods = { ...item }
      this.detailLoading = true
      let product_id = ''
      let item_id = item.item_id
      if (item.item_product) {
        product_id = item.item_product.product_id
        item_id = item.id
      } else {
        product_id = item.product_id
      }
      this.getAlienDetectionDetail2({
        data: { item_id: item_id, product_id: product_id },
        success: (res) => {
          this.detailLoading = false
          if (res.code === 200) {
            const { list, image_type_filter, trigger_word } = res.data
            this.oldImgList = list
            this.imageTypeFilter = image_type_filter
            this.triggerWord = trigger_word
            this.changeViolation()
          } else {
            this.$message.error(res.message)
          }
        }
      })
      this.changeMarkCheckAll(false)
    },
    changeViolation() {
      const image_type_filter = this.imageTypeFilter
      let list = this.oldImgList
      if (this.onlyViolation) {
        list = this.oldImgList.filter(item => item.status === 3)
      }
      const newData = {}
      this.imgList = []
      list.forEach(item => {
        if (!newData[item.image_type]) {
          newData[item.image_type] = {
            label: image_type_filter[item.image_type],
            list: []
          }
        }
        this.imgList.push(item.origin_url)
        newData[item.image_type].list.push(item)
      })
      this.detailInfo = Object.keys(newData).map(item => newData[item])
      this.selectImg(0, 0)
      this.processedImages = {}
      this.changeMarkCheckAll(false)
      this.handleImg()
    },
    changeAppraisalStatus(item, status) {
      this.opUpdateAppraisalStatus({
        data: { id: item.id, appraisal_status: status },
        success: (res) => {
          if (res.code === 200) {
            item.appraisal_status = status
            this.$message.success('操作成功')
          } else {
            this.$message.error(res.message)
          }
        }
      })
    },
    handleKeydown(event) {
      if (event.key === 'q' || event.key === 'Q') {
        this.handlePre()
      } else if (event.key === 'e' || event.key === 'E') {
        this.handleNext()
      } else if (event.key === 'w' || event.key === 'W') {
        this.handlePreGoods()
      } else if (event.key === 's' || event.key === 'S') {
        this.handleNextGoods()
      } else if (['f', 'a', 'd', 'F', 'A', 'D'].includes(event.key)) {
        const status = (event.key === 'f' || event.key === 'F') ? 1 : (event.key === 'a' || event.key === 'A') ? 2 : 3
        const item = this.tableData[this.currentGoodsIndex]
        if (item) this.changeAppraisalStatus(item, status)
      } else if (event.key === 'r' || event.key === 'R') {
        this.handleMarkImgSingle(1)
      } else if (event.key === 't' || event.key === 'T') {
        this.handleMarkImgSingle(0)
      }
    },
    handlePreGoods() {
      if (this.currentGoodsIndex === 0) {
        this.$message.warning('已是当前页面第一条数据了')
        return false
      } else if (this.currentGoodsIndex < 0) {
        this.currentGoodsIndex = 0
      } else {
        this.currentGoodsIndex--
      }
      this.selectGoods(this.tableData[this.currentGoodsIndex], this.currentGoodsIndex)
    },
    handleNextGoods() {
      if (this.currentGoodsIndex === this.tableData.length - 1) {
        this.$message.warning('已是当前页面最后一条数据了')
        return false
      } else if (this.currentGoodsIndex < 0) {
        this.currentGoodsIndex = 0
      } else {
        this.currentGoodsIndex++
      }
      this.selectGoods(this.tableData[this.currentGoodsIndex], this.currentGoodsIndex)
    },
    handlePre() {
      let index0 = this.currentImgIndex[0]
      let index1 = this.currentImgIndex[1]
      if (index0 === 0 && index1 === 0) return
      if (index0 >= 0) {
        if (index1 === 0) {
          index0--
          index1 = this.detailInfo[index0].list.length - 1
        } else {
          index1--
        }
      }
      this.selectImg(index0, index1)
    },
    handleNext() {
      let index0 = this.currentImgIndex[0]
      let index1 = this.currentImgIndex[1]
      if (index0 === this.detailInfo.length - 1 && index1 === this.detailInfo[index0].list.length - 1) return
      if (index0 < this.detailInfo.length) {
        if (index1 === this.detailInfo[index0].list.length - 1) {
          index0++
          index1 = 0
        } else {
          index1++
        }
      }
      this.selectImg(index0, index1)
    },
    selectImg(index0, index1) {
      this.currentImgIndex = [index0, index1]
    },
    handleImg() {
      this.previewList = []
      let list = this.oldImgList
      if (this.onlyViolation) {
        list = this.oldImgList.filter(item => item.status === 3)
      }
      list.forEach((item, index) => {
        if (item.status === 3 && item.remark_array && item.remark_array.length) {
          const processedUrl = this.getProcessedImageUrl(item, index)
          this.previewList.push(processedUrl)
        } else {
          this.previewList.push(item.origin_url)
        }
      })
    },
    handlePreview(imgData, bindex, sindex) {
      let globalIndex = 0
      for (let i = 0; i < bindex; i++) {
        globalIndex += this.detailInfo[i].list.length
      }
      globalIndex += sindex
      this.previewIndex = globalIndex
      this.previewShow = true
      if(this.imgMode==='more'){
        this.selectImg(bindex,sindex)
      }
    },
    previewNav(step) {
      let next = this.previewIndex + step
      if (next < 0) next = this.previewList.length - 1
      if (next > this.previewList.length - 1) next = 0
      this.previewIndex = next
    },
    closePreview() {
      this.previewShow = false
    },
    getProcessedImageUrl(imgData, index) {
      if (!imgData || !imgData.origin_url) return ''
      if (imgData.status !== 3 || !imgData.remark_array || !imgData.remark_array.length) {
        return imgData.origin_url
      }
      const cacheKey = imgData.image_id || imgData.origin_url
      if (this.processedImages[cacheKey]) {
        return this.processedImages[cacheKey]
      }
      this.processImageSync(imgData, index)
      return imgData.origin_url
    },
    getRandomColor() {
      const colors = [
        '#FF6B6B', '#4ECDC4', '#45B7D1', '#FFA07A', '#98D8C8', '#F7DC6F', '#BB8FCE', '#85C1E2',
        '#F8B739', '#52B788', '#E74C3C', '#3498DB', '#9B59B6', '#1ABC9C', '#F39C12', '#E67E22',
        '#16A085', '#27AE60', '#2980B9', '#8E44AD', '#C0392B', '#D35400', '#2ECC71', '#F1C40F',
        '#E91E63', '#00BCD4', '#FF9800', '#795548', '#607D8B', '#009688'
      ]
      return colors[Math.floor(Math.random() * colors.length)]
    },
    isRectOverlap(rect1, rect2, padding = 5) {
      return !(rect1.right + padding < rect2.left ||
        rect1.left - padding > rect2.right ||
        rect1.bottom + padding < rect2.top ||
        rect1.top - padding > rect2.bottom)
    },
    findTextPosition(points, textWidth, textHeight, imgWidth, imgHeight, occupiedAreas) {
      const minY = Math.min(points[0][1], points[1][1], points[2][1], points[3][1])
      const maxY = Math.max(points[0][1], points[1][1], points[2][1], points[3][1])
      const minX = Math.min(points[0][0], points[1][0], points[2][0], points[3][0])
      const maxX = Math.max(points[0][0], points[1][0], points[2][0], points[3][0])
      const centerX = (points[0][0] + points[1][0] + points[2][0] + points[3][0]) / 4
      const centerY = (minY + maxY) / 2
      const padding = 10
      const distanceLevels = [10, 20, 40, 60, 80, 100]
      const candidates = []
      distanceLevels.forEach(distance => {
        candidates.push(
          { x: centerX - textWidth / 2, y: maxY + distance + textHeight, priority: 1 },
          { x: centerX - textWidth / 2, y: minY - distance, priority: 2 },
          { x: maxX + distance, y: centerY, priority: 3 },
          { x: minX - textWidth - distance, y: centerY, priority: 4 },
          { x: maxX + distance, y: maxY + distance + textHeight, priority: 5 },
          { x: minX - textWidth - distance, y: maxY + distance + textHeight, priority: 6 },
          { x: maxX + distance, y: minY - distance, priority: 7 },
          { x: minX - textWidth - distance, y: minY - distance, priority: 8 }
        )
      })
      candidates.push(
        { x: centerX - textWidth / 2, y: maxY - 5, priority: 9 },
        { x: centerX - textWidth / 2, y: minY + textHeight + 5, priority: 10 }
      )
      for (let pos of candidates) {
        let x = pos.x
        let y = pos.y
        if (x < padding) x = padding
        if (x + textWidth > imgWidth - padding) x = imgWidth - padding - textWidth
        if (y < textHeight + padding) y = textHeight + padding
        if (y > imgHeight - padding) continue
        if (x < padding || x + textWidth > imgWidth - padding) continue
        const textRect = { left: x, top: y - textHeight, right: x + textWidth, bottom: y }
        let hasOverlap = false
        for (let area of occupiedAreas) {
          if (this.isRectOverlap(textRect, area, 5)) {
            hasOverlap = true
            break
          }
        }
        if (!hasOverlap) {
          return { x, y, rect: textRect }
        }
      }
      const gridSize = 50
      const cols = Math.floor(imgWidth / gridSize)
      const rows = Math.floor(imgHeight / gridSize)
      for (let row = 0; row < rows; row++) {
        for (let col = 0; col < cols; col++) {
          const x = col * gridSize + padding
          const y = row * gridSize + textHeight + padding
          if (x + textWidth > imgWidth - padding || y > imgHeight - padding) continue
          const textRect = { left: x, top: y - textHeight, right: x + textWidth, bottom: y }
          let hasOverlap = false
          for (let area of occupiedAreas) {
            if (this.isRectOverlap(textRect, area, 5)) {
              hasOverlap = true
              break
            }
          }
          if (!hasOverlap) {
            return { x, y, rect: textRect }
          }
        }
      }
      let x = imgWidth - textWidth - padding
      let y = imgHeight - padding
      if (x < padding) x = padding
      return { x, y, rect: { left: x, top: y - textHeight, right: x + textWidth, bottom: y } }
    },
    processImageSync(imgData, index) {
      const cacheKey = imgData.image_id || imgData.origin_url
      const img = new Image()
      img.crossOrigin = 'anonymous'
      img.onload = () => {
        const canvas = document.createElement('canvas')
        canvas.width = img.naturalWidth
        canvas.height = img.naturalHeight
        const ctx = canvas.getContext('2d')
        ctx.drawImage(img, 0, 0)
        const occupiedAreas = []
        imgData.remark_array.forEach((item, i) => {
          if (item.box && Array.isArray(item.box) && item.box.length === 4) {
            const points = item.box
            const color = i === 0 ? '#0066ff' : this.getRandomColor()
            const minX = Math.min(points[0][0], points[1][0], points[2][0], points[3][0])
            const maxX = Math.max(points[0][0], points[1][0], points[2][0], points[3][0])
            const minY = Math.min(points[0][1], points[1][1], points[2][1], points[3][1])
            const maxY = Math.max(points[0][1], points[1][1], points[2][1], points[3][1])
            occupiedAreas.push({ left: minX, top: minY, right: maxX, bottom: maxY })
            ctx.strokeStyle = color
            ctx.lineWidth = Math.max(3, img.naturalWidth / 400)
            ctx.beginPath()
            ctx.moveTo(points[0][0], points[0][1])
            ctx.lineTo(points[1][0], points[1][1])
            ctx.lineTo(points[2][0], points[2][1])
            ctx.lineTo(points[3][0], points[3][1])
            ctx.closePath()
            ctx.stroke()
            if (item.remark) {
              const fontSize = 14
              ctx.font = `bold ${fontSize}px Arial`
              const textMetrics = ctx.measureText(item.remark)
              const textWidth = textMetrics.width
              const textHeight = fontSize
              const textPos = this.findTextPosition(points, textWidth, textHeight, img.naturalWidth, img.naturalHeight, occupiedAreas)
              occupiedAreas.push(textPos.rect)
              ctx.strokeStyle = '#ffffff'
              ctx.lineWidth = 5
              ctx.strokeText(item.remark, textPos.x, textPos.y)
              ctx.fillStyle = color
              ctx.fillText(item.remark, textPos.x, textPos.y)
            }
          }
        })
        const processedUrl = canvas.toDataURL('image/png')
        this.$set(this.processedImages, cacheKey, processedUrl)
        this.previewList[index] = processedUrl
      }
      img.onerror = () => {
        this.$set(this.processedImages, cacheKey, imgData.origin_url)
        this.previewList[index] = imgData.origin_url
      }
      img.src = imgData.origin_url
    },
    switchImgMode(mode) {
      this.imgMode = mode
      this.changeMarkCheckAll(false)
    },
    handleDelImg(val, index) {
      this.$confirm('注：删除时，注意主图小于3张、详情图全部删除会导致商品下架。SKU图如与首规格数量不一致，会导致商品无SKU图！！！确定要删除图片吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.opAlienDetailDelBatch({
          data: { item_id: val.item_id, image_ids: val.image_id, product_id: val.product_id },
          success: (res) => {
            if (res.code === 200) {
              this.detailInfo[index[0]].list.splice(index[1], 1)
              this.$message.success('删除成功')
              this.selectGoods(this.currentGoods, this.currentGoodsIndex)
            } else {
              this.$message.error(res.message)
            }
          }
        })
      }).catch(() => {})
    },
    handleDelImgBatch() {
      this.$confirm(`注：删除时，注意主图小于3张、详情图全部删除会导致商品下架。SKU图如与首规格数量不一致，会导致商品无SKU图！！！确定删除${this.markCheckList.length}张图片吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.delLoading = true
        const imgIdsArr = this.oldImgList.filter(i => this.markCheckList.includes(i.detail_id)).map(i => i.image_id)
        this.opAlienDetailDelBatch({
          data: {
            item_id: this.currentGoods.item_id,
            product_id: this.currentGoods.product_id,
            image_ids: imgIdsArr.join(',')
          },
          success: (res) => {
            if (res.code === 200) {
              this.$message.success('删除成功')
              this.getDataList(this.pageData.page)
            } else {
              this.$message.error(res.message)
            }
            this.delLoading = false
          }
        })
      }).catch(() => {})
    },
    handleCheckAllChange(val) {
      this.tableData.forEach(i => {
        i.checked = val
      })
      const allArr = this.tableData.map(i => {
        return i.item_product ? i.item_product.id : i.id
      })
      this.checkedList = val ? [...new Set([...this.checkedList, ...allArr])] : this.checkedList.filter(i => !allArr.includes(i))
    },
    handleCheckSingleChange(e, row) {
      const check_id = row.item_product ? row.item_product.id : row.id
      if (!e) {
        this.checkedList = this.checkedList.filter(i => i !== check_id)
        row.checked = false
      } else {
        this.checkedList.push(check_id)
        row.checked = true
      }
    },
    handleClearAll() {
      this.checkedList = []
      this.tableData.forEach(i => {
        i.checked = false
      })
    },
    batchDown() {
      if (!this.checkedList.length) {
        this.$message.warning('请选择要下架的商品')
        return false
      }
      this.$confirm(`确定要下架【${this.checkedList.length}】个商品吗？`, '提示', { type: 'warning' }).then(() => {
        this.opAlienBatchOperation({
          data: { ids: this.checkedList.join(','), type: 1 },
          success: (res) => {
            if (res.code === 200) {
              this.$message.success('下架成功')
              this.handleClearAll()
              this.handleSearch()
            } else {
              this.$message.error(res.message)
            }
          }
        })
      }).catch(() => {})
    },
    handleBatchSetGroup() {
      if (!this.checkedList.length) {
        this.$message.warning('请先选择商品')
        return
      }
      this.batchGroupId = 0
      this.batchChildGroupId = 0
      this.batchChildGroupList = []
      this.batchGroupShow = true
    },
    submitBatchSetGroup() {
      if (this.batchGroupId === null || this.batchGroupId === '') {
        this.$message.warning('请选择分组')
        return
      }
      this.batchGroupLoading = true
      const isRemoveGroup = this.batchGroupId == 0
      this.opCloudProductBatchSetGroup({
        data: {
          product_ids: this.checkedList,
          group_id: isRemoveGroup ? null : this.batchGroupId,
          child_group_id: this.batchChildGroupId == 0 ? null : this.batchChildGroupId
        },
        success: (res) => {
          this.batchGroupLoading = false
          if (res.code === 200) {
            this.batchGroupShow = false
            this.$message.success(isRemoveGroup ? '已去除分组' : '加入分组成功')
            this.handleClearAll()
            this.handleSearch()
          } else {
            this.$message.error(res.message)
          }
        }
      })
    },
    changeBatchGroupIds(val) {
      this.batchChildGroupId = 0
      this.batchChildGroupList = this.groupList.filter(i => i.id == val).map(i => i.child_groups || []).flat()
    },
    changeGroupIds(val) {
      this.$set(this.searchParams, 'child_group_id', [])
      this.childGroupList = this.groupList.filter(i => val.includes(i.id)).map(i => i.child_groups || []).flat()
    },
    changeMarkCheckAll(val) {
      let list = []
      if (val) {
        if (this.onlyViolation) {
          list = this.oldImgList.filter(item => item.status === 3).map(item => item.detail_id)
        } else {
          list = this.oldImgList.map(item => item.detail_id)
        }
      }
      this.markCheckList = list
      this.markIsIndeterminate = false
      this.markCheckAll = !!val && list.length > 0
    },
    changeMarkCheckSingle(val, id) {
      if (val) {
        this.markCheckList.push(id)
      } else {
        this.markCheckList = this.markCheckList.filter(item => item !== id)
      }
      let list = []
      if (this.onlyViolation) {
        list = this.oldImgList.filter(item => item.status === 3).map(item => item.detail_id)
      } else {
        list = this.oldImgList.map(item => item.detail_id)
      }
      this.markCheckAll = list.length > 0 && list.length === this.markCheckList.length
      this.markIsIndeterminate = this.markCheckList.length > 0 && this.markCheckList.length < this.oldImgList.length
    },
    handleMarkImg(is_mark) {
      this.$confirm(`确定要${is_mark == 1 ? '标记为违规' : '标记为正常'}吗？`, '提示', { type: 'warning' }).then(() => {
        const ids = this.markCheckList.join(',')
        this.submitMarkImg(is_mark, ids)
      }).catch(() => {})
    },
    handleMarkImgSingle(is_mark) {
      if (this.imgMode == 'list') return
      if (!this.currentImg.detail_id) return
      this.submitMarkImg(is_mark, this.currentImg.detail_id)
    },
    submitMarkImg(is_mark, ids) {
      const params = {
        item_id: this.currentGoods.item_id,
        ids: ids,
        is_mark: is_mark
      }
      if (is_mark == 1) {
        this.markLoadingR = true
      } else {
        this.markLoadingT = true
      }
      this.opAlienDetailMark({
        data: params,
        success: (res) => {
          if (res.code === 200) {
            this.$message.success('标记成功')
            this.markCheckList = []
            this.markCheckAll = false
            this.markIsIndeterminate = false
            if (String(ids).split(',').length > 1) {
              this.selectGoods(this.currentGoods, this.currentGoodsIndex)
            } else if (this.detailInfo[this.currentImgIndex[0]] && this.detailInfo[this.currentImgIndex[0]].list[this.currentImgIndex[1]]) {
              this.detailInfo[this.currentImgIndex[0]].list[this.currentImgIndex[1]].is_mark = is_mark
            }
          } else {
            this.$message.error(res.message)
          }
          this.markLoadingR = false
          this.markLoadingT = false
        }
      })
    },
    handleDelDesignate() {
      if (!this.currentGoods.item_id || this.currentGoods.item_id === 0) {
        this.$message.warning('商品未检测，无法执行指定项删除')
        return
      }
      this.delDesignateType = 'one'
      this.delDesignateInfo = this.buildDelDesignateInfo()
      this.delDesignateShow = true
    },
    handleDelDesAll() {
      this.delDesignateType = 'all'
      this.delDesignateInfo = this.buildDelDesignateInfo(true)
      this.delChildGroupList = []
      this.delDesignateShow = true
    },
    buildDelDesignateInfo(withGroup = false) {
      const base = { detection_type: this.activeTab }
      if (withGroup) {
        base.group_ids = []
        base.child_group_id = []
      } else {
        base.item_id = this.currentGoods.item_id
      }
      if (this.activeTab == 9) {
        base.is_counterfeit = 0
        base.is_inducement = 0
        base.is_prohibited = 0
        base.is_copyright = 0
        base.is_portrait = 0
        base.is_false_promotion = 0
        base.is_diffrent_material = 0
      }
      if (this.activeTab == 8) {
        base.is_medical_effect_false = 0
        base.is_special_effect_false = 0
        base.is_other_effect_false = 0
        base.is_device_drug_inconsistent = 0
      }
      return base
    },
    submitDelDesignate() {
      const keys9 = ['is_counterfeit', 'is_inducement', 'is_prohibited', 'is_copyright', 'is_portrait', 'is_false_promotion', 'is_diffrent_material']
      const keys8 = ['is_medical_effect_false', 'is_special_effect_false', 'is_other_effect_false', 'is_device_drug_inconsistent']
      const keys = this.activeTab == 9 ? keys9 : keys8
      const flag = keys.every(key => this.delDesignateInfo[key] === 0)
      if (flag) {
        this.$message.warning('请选择违规项')
        return
      }
      this.delLoading2 = true
      const done = (res) => {
        this.delLoading2 = false
        if (res.code === 200) {
          this.$message.success('删除任务提交成功')
          this.delDesignateShow = false
          if (this.delDesignateType === 'one') {
            this.selectGoods(this.currentGoods, this.currentGoodsIndex)
          }
        } else {
          this.$message.error(res.message)
        }
      }
      if (this.delDesignateType === 'one') {
        this.opAlienDetailDelDesignate({ data: this.delDesignateInfo, success: done })
      } else {
        this.opAlienItemDelDesignateAll({ data: this.delDesignateInfo, success: done })
      }
    },
    handleDelMarkAll() {
      this.$confirm('确定要删除所有标记的图片吗？', '提示', { type: 'warning' }).then(() => {
        this.opAlienDelMarkAll({
          data: {},
          success: (res) => {
            if (res.code === 200) {
              this.$message.success('删除任务提交成功')
            } else {
              this.$message.error(res.message)
            }
          }
        })
      }).catch(() => {})
    },
    changeDeldesignateGroupIds(val) {
      this.$set(this.delDesignateInfo, 'child_group_id', [])
      this.delChildGroupList = this.groupList.filter(i => val.includes(i.id)).map(i => i.child_groups || []).flat()
    }
  }
}
</script>

<style scoped>
.search-wrap :deep(.el-form--label-top .el-form-item__label){
  font-size: 10px;
  line-height: 15px;
  color: #999999;
  margin-bottom: 4px;
}
.gx-al {
  font-family: 'Noto Sans SC', sans-serif;
}
.gx-al__head {
  display: flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 16px;
}
.gx-al__title {
  font-family: 'Noto Serif SC', serif;
  font-size: 24px;
  font-weight: 600;
  color: #1A1A2E;
}
.gx-al__tabs {
  display: flex;
  align-items: center;
  /* gap: 6px; */
  margin-bottom: 14px;
  border-bottom: 1px solid #E1E5EE;
  flex-wrap: wrap;
}
.gx-al__tab {
  padding: 0 20px;
  height: 40px;
  line-height: 40px;
  border: none;
  cursor: pointer;
  background: #fff;
  font-size: 14px;
  color: #606266;
  position: relative;
  -webkit-transition: color .2s;
  transition: color .2s;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 104px;
}
.gx-al__tab--on {
  color: rgb(212, 169, 70);
  font-weight: 600;
}
.gx-al__tab--on::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 4px;
  right: 4px;
  height: 2px;
  border-radius: 2px 2px 0 0;
  background: rgb(212, 169, 70);
}
.gx-al__expand {
  margin-left: auto;
  border: none;
  background: transparent;
  cursor: pointer;
  font-size: 12px;
  color: #6A6A8A;
}
.gx-al__filter {
  border-radius: 12px;
  padding: 14px 16px;
  margin-bottom: 14px;
  background: #FFFFFF;
  border: 1px solid #E1E5EE;
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.gx-al__frow {
  display: flex;
  gap: 12px;
  align-items: flex-end;
  flex-wrap: wrap;
}
.gx-al__frow--bottom {
  align-items: center;
}
.gx-al__fitem--col {
  display: flex;
  flex-direction: column;
  gap: 6px;
  align-items: flex-start;
}
.gx-al__flabel {
  font-size: 12px;
  color: #6A6A8A;
  white-space: nowrap;
}
.gx-al__btns {
  display: flex;
  gap: 10px;
}
.gx-al__input {
  width: 150px;
  height: 30px;
  padding: 0 10px;
  border-radius: 6px;
  border: 1px solid #DCDFE6;
  font-size: 12px;
  color: #1A1A2E;
  outline: none;
  box-sizing: border-box;
  background: #FFFFFF;
}
.gx-al__select {
  height: 30px;
  padding: 0 8px;
  border-radius: 6px;
  border: 1px solid #DCDFE6;
  background: #FFFFFF;
  font-size: 12px;
  color: #1A1A2E;
  outline: none;
  min-width: 120px;
}
.gx-al__select--full {
  width: 100%;
  min-width: 0;
}
.gx-al__btn {
  height: 30px;
  padding: 0 16px;
  border-radius: 6px;
  cursor: pointer;
  background: #FFFFFF;
  border: 1px solid #DCDFE6;
  font-size: 12px;
  color: #606266;
  display: inline-flex;
  align-items: center;
  gap: 5px;
  transition: all .16s;
}
.gx-al__btn:hover {
  background: #F5F7FA;
  border-color: #C0C4CC;
}
.gx-al__btn--primary {
  background: linear-gradient(135deg, rgb(212, 169, 70), rgb(232, 199, 120));
  font-weight: 500;
  color: #FFFFFF;
  box-shadow: none;
  filter: brightness(1);
}
.gx-al__btn--primary:hover {
  filter: brightness(1.08);
  background: linear-gradient(135deg, rgb(212, 169, 70), rgb(232, 199, 120));
}
.gx-al__btn:disabled {
  opacity: .5;
  cursor: not-allowed;
}
.gx-al__content {
  display: flex;
  gap: 14px;
  height: 72vh;
  min-height: 560px;
}
.gx-al__left {
  width: 460px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  border: 1px solid #E1E5EE;
  border-radius: 12px;
  background: #FFFFFF;
  padding: 10px;
}
.gx-al__progress {
  display: flex;
  gap: 20px;
  padding: 9px 16px;
  border-radius: 8px;
  background: rgb(255, 251, 230);
  border: 1px solid rgb(255, 229, 143);
  margin-bottom: 10px;
  flex-wrap: wrap;
  align-items: center;
}
.gx-al__progress_tip{
  font-size: 12px;
  font-weight: 700;
  color: rgb(251, 146, 60);
}
.gx-al__progress_label{
  font-size: 11px;
  color: rgb(102, 102, 102);
}
.gx-al__progress_txt{
  font-size: 13px;
  font-weight: 700;
  color: rgb(153, 153, 153);
}
.gx-al__red {
  color: #F87171;
}
.gx-al__green {
  color: #22C55E;
}
.gx-al__leftbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 4px 0;
  flex-wrap: wrap;
  gap: 6px;
}
.gx-al__checkall {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  font-size: 13px;
  color: #1A1A2E;
  margin-right: 8px;
  user-select: none;
}
.gx-al__checkall input[type='checkbox'],
.gx-al__goodscheck input[type='checkbox'],
.gx-al__check input[type='checkbox'] {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
}
.gx-al__box {
  width: 15px;
  height: 15px;
  border-radius: 4px;
  border: 1.5px solid rgba(212, 169, 70, .3);
  background: #FFFFFF;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: all .15s;
  position: relative;
}
.gx-al__box--on {
  background: linear-gradient(135deg, #D4A946, #E8C778);
  border-color: transparent;
}
.gx-al__box-dash {
  width: 7px;
  height: 2px;
  border-radius: 1px;
  background: #D4A946;
}
.gx-al__shortcuts {
  position: relative;
  font-size: 12px;
  color: #4A4A6A;
}
.gx-al__shortcut-title {
  cursor: pointer;
  padding: 4px 8px;
}
.gx-al__shortcut-panel {
  display: none;
  position: absolute;
  right: 0;
  top: 26px;
  z-index: 50;
  background: #FFFFFF;
  border: 1px solid #E1E5EE;
  border-radius: 8px;
  box-shadow: 0 10px 30px rgba(15, 23, 42, .12);
  padding: 10px 12px;
  font-size: 11px;
  color: #4A4A6A;
  line-height: 1.9;
  white-space: nowrap;
}
.gx-al__shortcuts:hover .gx-al__shortcut-panel {
  display: block;
}
.gx-al__goodslist {
  flex: 1;
  overflow-y: auto;
  border: 1px solid #E1E5EE;
  border-radius: 10px;
  background: #FBFBFD;
}
.gx-al__goodsitem {
  display: flex;
  padding: 8px 4px;
  border-bottom: 1px solid #EEF1F6;
}
.gx-al__goodscheck {
  margin: 30px 6px 0 4px;
  flex-shrink: 0;
  cursor: pointer;
  display: inline-flex;
}
.gx-al__iteminfo {
  flex: 1;
  min-width: 0;
  padding: 8px;
  border-radius: 10px;
  border: 1px solid transparent;
  cursor: pointer;
  font-size: 12px;
}
.gx-al__iteminfo--on {
  border-color: #FA5757;
  background: rgba(250, 87, 87, .04);
}
.gx-al__itemhead {
  display: flex;
  gap: 10px;
}
.gx-al__itemimg {
  width: 72px;
  height: 72px;
  border-radius: 8px;
  overflow: hidden;
  background: #F5F0E8;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  flex-shrink: 0;
}
.gx-al__itemimg img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.gx-al__itembody {
  flex: 1;
  min-width: 0;
}
.gx-al__itemtitle {
  font-size: 12px;
  color: #1A1A2E;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.gx-al__itemmeta {
  font-size: 11px;
  color: #6A6A8A;
  margin-top: 4px;
  line-height: 1.6;
  word-break: break-all;
}
.gx-al__appraisal {
  display: flex;
  gap: 5px;
  flex-wrap: wrap;
  margin-top: 6px;
}
.gx-al__appraisal-tag {
  padding: 2px 8px;
  border-radius: 10px;
  font-size: 11px;
  cursor: pointer;
  border: 1px solid #E1E5EE;
  background: #FFFFFF;
  color: #4A4A6A;
}
.gx-al__appraisal-tag--on {
  background: rgba(212, 169, 70, .12);
  border-color: rgba(212, 169, 70, .5);
  color: #D4A946;
}
.gx-al__itemstat {
  /* color: #FF4500; */
  margin-top: 6px;
  line-height: 1.6;
  font-size: 11px;
  color: rgb(153, 153, 153);
}
.gx-al__itemnum{
  font-weight: 600;
  color: rgb(200, 68, 60);
}
.gx-al__tag {
  padding: 1px 6px;
  border-radius: 4px;
  background: rgba(139, 157, 195, .1);
  border: 1px solid rgba(139, 157, 195, .3);
  color: #6A6A8A;
  font-size: 11px;
}
.gx-al__tag--ok {
  background: rgba(74, 222, 128, .1);
  border-color: rgba(74, 222, 128, .3);
  color: #22C55E;
}
.gx-al__empty {
  text-align: center;
  padding: 40px 0;
  color: #6A6A8A;
  font-size: 13px;
}
.gx-al__right-empty {
  flex: 1;
  border: 1px solid #E1E5EE;
  border-radius: 12px;
  background: #FFFFFF;
  display: flex;
  align-items: center;
  justify-content: center;
}
.gx-al__pager {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 8px;
  gap: 6px;
  flex-wrap: wrap;
}
.%s__pager-left {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}
.gx-al__pager-total {
  font-size: 12px;
  color: #6A6A8A;
}
.gx-al__pager-select{
  width: 80px;
  margin-left: 4px;
}
.gx-al__pager-select :deep(.el-select i){
  font-size: 10px;
}
.gx-al__pager-select :deep(.el-input__suffix){
  right: 0;
}
.gx-al__pager-select :deep( .el-input__inner){
  padding-left: 5px;
  padding-right: 15px;
}
.gx-al__pager-btns {
  display: flex;
  gap: 4px;
  flex-wrap: wrap;
}
.gx-al__page {
  min-width: 26px;
  height: 26px;
  padding: 0 6px;
  border-radius: 5px;
  border: 1px solid #E1E5EE;
  background: #FFFFFF;
  cursor: pointer;
  font-family: 'JetBrains Mono', monospace;
  font-size: 11px;
  color: #4A4A6A;
}
.gx-al__page:disabled {
  opacity: .5;
  cursor: not-allowed;
}
.gx-al__page--on {
  background: linear-gradient(135deg, #D4A946, #E8C778);
  border: none;
  color: #F4F6F8;
  font-weight: 700;
}
.gx-al__right {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  border: 1px solid #E1E5EE;
  border-radius: 12px;
  background: #FFFFFF;
  overflow: hidden;
}
.gx-al__toolbar {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 14px;
  border-bottom: 1px solid #E1E5EE;
  flex-wrap: wrap;
}
.gx-al__seg {
  display: flex;
  gap: 6px;
}
.gx-al__seg-btn {
  height: 28px;
  padding: 0 14px;
  border-radius: 7px;
  border: 1px solid #E1E5EE;
  background: #FFFFFF;
  cursor: pointer;
  font-size: 12px;
  color: #4A4A6A;
}
.gx-al__seg-btn--on {
  background: linear-gradient(135deg, #C8443C, #F07575);
  border-color: transparent;
  color: #F4F6F8;
  font-weight: 600;
}
.gx-al__check {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  font-size: 12px;
  color: #4A4A6A;
}
.gx-al__check--block {
  display: flex;
  margin-bottom: 6px;
}
.gx-al__markbar {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-left: auto;
  flex-wrap: wrap;
}
.gx-al__op {
  height: 26px;
  padding: 0 10px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 11px;
  border: 1px solid #E1E5EE;
  background: #FFFFFF;
  color: #4A4A6A;
  white-space: nowrap;
  transition: all .15s;
}
.gx-al__op:disabled {
  opacity: .5;
  cursor: not-allowed;
}
.gx-al__op--danger {
  color: #F87171;
  border-color: rgba(248, 113, 113, .3);
}
.gx-al__op--loading {
  opacity: .6;
}
.gx-al__desc {
  padding: 10px 14px;
  border-bottom: 1px solid #E1E5EE;
  font-size: 12px;
  color: #1A1A2E;
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.gx-al__imgarea {
  flex: 1;
  overflow-y: auto;
  padding: 12px 14px;
  display: grid;

  gap: 20px;
}
.gx-al__imgarea--more{
  grid-template-columns: 1.2fr 1fr;
}
.gx-al__imgmore {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 12px 0;
}
.gx-al__imgmain-img {
  max-width: 100%;
  border-radius: 10px;
  border: 1px solid #E1E5EE;
  cursor: zoom-in;
}
.gx-al__imgmain .big-img {
  max-height: 520px;
}
.gx-al__imgmain .medium-img {
  max-height: 400px;
}
.gx-al__imgmain .small-img {
  max-height: 280px;
}
.gx-al__imgbtns {
  display: flex;
  gap: 6px;
  margin-top: 10px;
  flex-wrap: wrap;
  justify-content: center;
}
.gx-al__imgremark {
  margin-top: 14px;
  font-size: 13px;
  max-width: 80%;
  text-align: left;
}
.gx-al__imggroups {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.gx-al__imglabel {
  font-size: 12px;
  color: #1A1A2E;
  margin: 8px 0 6px;
}
.gx-al__imglist {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.gx-al__imgitem {
  position: relative;
  width: 104px;
  border: 1px solid #E1E5EE;
  border-radius: 8px;
  padding: 4px;
  background: #FFFFFF;
}
.gx-al__imgitem--on {
  border-color: rgb(212, 169, 70);
  box-shadow: 0 0 0 2px rgba(212, 169, 70, .25);
}
.gx-al__imgcheck {
  position: absolute;
  top: 4px;
  left: 4px;
  z-index: 2;
}
.gx-al__imgmark {
  position: absolute;
  top: 4px;
  right: 4px;
  z-index: 2;
}
.gx-al__imgthumb {
  display: block;
  width: 100%;
  aspect-ratio: 1 / 1;
  border-radius: 6px;
  overflow: hidden;
  background: #F5F0E8;
  cursor: zoom-in;
}
.gx-al__imgthumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.gx-al__imgdel {
  position: absolute;
  top: 4px;
  right: 4px;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: none;
  background: rgba(248, 113, 113, .85);
  color: #fff;
  font-size: 10px;
  cursor: pointer;
  z-index: 2;
}
.gx-al__imgremark--sm {
  font-size: 11px;
  margin-top: 4px;
  word-break: break-word;
}
.gx-al__modal {
  position: fixed;
  inset: 0;
  z-index: 700;
  background: rgba(0, 0, 0, .48);
  backdrop-filter: blur(6px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
}
.gx-al__modal-box {
  width: 100%;
  max-width: 520px;
  border-radius: 16px;
  background: #FFFFFF;
  border: 1px solid rgba(212, 169, 70, .28);
  box-shadow: 0 20px 56px rgba(15, 23, 42, .14);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  max-height: 90vh;
}
.gx-al__modal-box--sm {
  max-width: 440px;
}
.gx-al__modal-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px 20px;
  border-bottom: 1px solid #E1E5EE;
  flex-shrink: 0;
  background: #FFFFFF;
}
.gx-al__modal-title {
  font-family: 'Noto Serif SC', serif;
  font-size: 15px;
  font-weight: 600;
  color: #1A1A2E;
}
.gx-al__modal-close {
  background: none;
  border: none;
  cursor: pointer;
  color: #6A6A8A;
  font-size: 14px;
}
.gx-al__modal-body {
  padding: 18px 20px;
  overflow-y: auto;
}
.gx-al__modal-foot {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 12px 20px;
  border-top: 1px solid #E1E5EE;
  flex-shrink: 0;
  align-items: center;
  background: #FFFFFF;
}
.gx-al__field {
  margin-bottom: 14px;
}
.gx-al__label {
  display: block;
  font-size: 12px;
  color: #4A4A6A;
  margin-bottom: 6px;
}
.gx-al__dim {
  font-size: 11px;
  color: #6A6A8A;
  margin-top: 4px;
}
.gx-al__modal--preview {
  z-index: 750;
}
.gx-al__preview {
  position: relative;
  max-width: 92vw;
  max-height: 92vh;
}
.gx-al__preview-img {
  max-width: 92vw;
  max-height: 92vh;
  border-radius: 10px;
  background: #fff;
}
.gx-al__preview-close {
  position: absolute;
  top: -40px;
  right: 0;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: none;
  background: rgba(255, 255, 255, .15);
  color: #fff;
  font-size: 14px;
  cursor: pointer;
}
.gx-al__preview-nav {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: none;
  background: rgba(255, 255, 255, .15);
  color: #fff;
  font-size: 24px;
  cursor: pointer;
}
.gx-al__preview-nav--prev {
  left: -52px;
}
.gx-al__preview-nav--next {
  right: -52px;
}
.gx-al__preview-count {
  position: absolute;
  bottom: -36px;
  left: 50%;
  transform: translateX(-50%);
  color: #fff;
  font-size: 13px;
}
@media (max-width: 1200px) {
  .gx-al__content {
    flex-direction: column;
    height: auto;
  }
  .gx-al__left {
    width: 100%;
    max-height: 420px;
  }
}
</style>
